import { AdaptedMetricType } from '../monitoringTypes';

/**
 * Check if granularity is supported for a given chart/metric
 * Granularity is only supported for NODE entity types, not DB entity types
 * @param chart - The chart/metric to check
 * @returns true if granularity is supported, false otherwise
 */
export const isGranularitySupported = (
  chart: AdaptedMetricType | null | undefined,
): boolean => {
  return chart?.entityType === 'NODE';
};
